import {
  getAdoConnectorApiName,
  getGitHubConnectorApiName,
} from '@/services/repoConnectionService';
import { extractConnectorName } from '@/utils/connections';

const HIDDEN_CONNECTORS = new Set([
  getGitHubConnectorApiName().toLowerCase(),
  getAdoConnectorApiName().toLowerCase(),
  'azurelogicappsgithub',
  'azurelogicappsado',
]);

/** Repo OAuth connectors are credentials for internal features, not app connections. */
export function isAppConnectionConnectorVisible(connectorId: string): boolean {
  return !HIDDEN_CONNECTORS.has(extractConnectorName(connectorId).toLowerCase());
}
